import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect as ReactRouterRedirect } from 'react-router-dom';

/**
 * A helper component to make sure a redirect outside of the app works both server side and client side
 *
 * The <Redirect /> component from react-router-dom only does a "history" replace when it is rendered
 * client side. So when we redirect to the login page, the user is only presented with a blank page (since)
 * our app doesn't serve /user/acct/login . By using a useEffect, which only runs client side, we can make
 * sure we get a full redirect.
 *
 * This is only relevant when doing client side navigation from a page that does not require auth to one
 * that does.
 * @param {Object} props
 * @param {String} props.to
 * @returns {ReactRouterRedirect}
 */
export default function ExternalRedirect({ to }) {
  useEffect(() => {
    if (to) {
      window.location.href = to;
    }
  }, [to]);
  return <ReactRouterRedirect to={to} />;
}

ExternalRedirect.propTypes = {
  to: PropTypes.string,
};
